<template>
  <div class="family">
    <div class="image-container">
      <img src="../assets/images/image-1200w.jpg"
        alt="A sample image"
        class="responsive-image"
        srcset="../assets/images/image-300w.jpg 300w, ../assets/images/image-600w.jpg 600w, ../assets/images/image-1200w.jpg 1200w"
        sizes="(max-width: 600px) 100vw, 50vw">
    </div>
    <div class="text-container">
      <h1>Hello from Julia and Alexander!</h1>
      <p>We live in Stockholm, Sweden and have 2 kids - Sofia and Daniel.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Family'
}
</script>

<style scoped>
.family {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.image-container {
  flex: 1;
  max-width: 60%;
}

.text-container {
  flex: 1;
  max-width: 40%;
  padding-top: 20px;
}

h1 {
  font-size: 2rem;
  margin-bottom: 10px;
  margin-top: 0;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

@media (max-width: 768px) {
  .family {
    flex-direction: column;
    gap: 20px;
    padding: 0 15px;
  }

  .image-container,
  .text-container {
    max-width: 100%;
    padding-top: 0;
  }

  .text-container {
    padding: 0 10px;
  }

  h1 {
    font-size: 1.5rem;
    text-align: center;
  }

  p {
    text-align: center;
    padding: 0 5px;
  }
}
</style>
